"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBannerSplit = void 0;
var _PromoBannerImage = require("../PromoBannerImage");
var _PromoBannerText = require("../PromoBannerText");
var _PromoBannerVideo = require("../PromoBannerVideo");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBannerSplit = (param)=>{
    let { size, backgroundImage, backgroundVideo, link, promoBannerType, title } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            backgroundImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PromoBannerImage.PromoBannerImage, {
                size: size,
                promoBannerType: promoBannerType,
                backgroundImage: backgroundImage,
                link: link
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PromoBannerVideo.PromoBannerVideo, {
                size: size,
                promoBannerType: promoBannerType,
                backgroundVideo: backgroundVideo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PromoBannerText.PromoBannerText, {
                size: size,
                promoBannerType: promoBannerType,
                link: link,
                title: title
            })
        ]
    });
};
exports.PromoBannerSplit = PromoBannerSplit;
